/**
 * https://gitlab.digitalnatives.nl/toolkit/css-variables/-/blob/master/themes/default/styles/boxShadow.js
 */
export default {
    light: '0px 0px 8px rgba(0, 0, 0, 0.06)',
    medium: '0px 0px 6px rgba(0, 0, 0, 0.16)',
    inset: 'inset 1px 1px 4px rgba(0, 0, 0, 0.06)'
};
